<script>
import { maLocalStorage } from '@/lib/storage'
import { getAuthRedirectUri, paramsToQuery, randomString } from '@/base/MaUtils'

import { MaSocialButton } from '@mobileaction/action-kit'

const GOOGLE_CLIENT_ID = '570314969741-dlqafcm0oilcs2oag0b2vu2glsq1hse9.apps.googleusercontent.com'

export default {
  name: 'MaSocialLoginRowRegister',
  components: {
    MaSocialButton,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      loginCsrf: null,
    }
  },
  computed: {
    googleAuthUrl() {
      return `https://accounts.google.com/o/oauth2/v2/auth?${paramsToQuery({
        scope: ['email', 'profile', 'openid'].join(' '),
        access_type: 'offline',
        include_granted_scopes: true,
        state: this.loginCsrf,
        redirect_uri: getAuthRedirectUri('google'),
        response_type: 'code',
        client_id: GOOGLE_CLIENT_ID,
      })}`
    },
  },
  mounted() {
    this.loginCsrf = maLocalStorage.loginCsrf = randomString()
  },
}
</script>

<template>
  <MaSocialButton
    :href="googleAuthUrl"
    :disabled="loading"
    brand="google"
    variant="stroke"
    size="x-large"
    class="w-full"
  >
    Continue with Google
  </MaSocialButton>
</template>
